
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/savePublish/panels/save/feedbackPanel/feedbackPanel.scss.css.virtualfile';
        module.exports = {"modal":"_modal_mmb9m_1","content":"_content_mmb9m_4","rating":"_rating_mmb9m_7","textarea":"_textarea_mmb9m_10"};